import { Loader2 } from "lucide-react";

/** Overlay affiché quand la sauvegarde d'une page traîne : signale au candidat
 * que la transition est en cours, et couvre l'ancienne page qu'il pourrait
 * sinon croire encore active. */
export function FormTransitionOverlay({ open }: { open: boolean }) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 grid place-items-center bg-background/60 backdrop-blur-[1px]"
      role="status"
      aria-live="polite"
    >
      <div className="flex items-center gap-3 rounded-surface border bg-card px-4 py-3 shadow-lg">
        <Loader2 className="h-5 w-5 animate-spin text-primary" />
        <span className="text-sm">Enregistrement de vos réponses...</span>
      </div>
    </div>
  );
}
